import React, { useEffect, useState } from 'react';
import BlogBox from './BlogBox';
import './BlogsContainer.css'
import { Axios } from '../../../../Components/Helpers/Axios';
import SeoHelmet from '../../../../Components/SeoHelmet';
const BlogsContainer = () => {
  const [data , setData] = useState([]);

  useEffect(()=>{
    Axios.get('/blogs').then(data=>setData(data.data.data))


  },[])
  
  return (
    <>
      <SeoHelmet
        title="SunMed | Blog"
        description="SunMed: One Team with All Services under one roof — media production, social
        media, design, events, and web — all flowing from a unified creative
        vision.."
        keywords="SunMed, media production, web solutions, digital marketing, education, event management"
        url="https://sunmed.com"
        image="https://sunmed.com/images/sunmed-home-og.jpg"
      />
    <div  className='BlogsContainer py-2 md:py-9 md:px-[7vw] px-[3vw]' >
      {
        data.map((data,index)=>(
    

          <BlogBox key={index} cover={data.cover} id={data.uuid} content={data.content} title={data.title}/>
        ))
      }
    
    </div>
      <div className="text-center  bg-[#fafafa] py-5">
        {/* <button className='normal-btn'>Load more</button> */}
      </div>
    </>
  );
}

export default BlogsContainer;
